import { ICLContainer } from './ICLContainer';

const App = () => <ICLContainer />;

export default App;
